import type { ReactNode } from "react";
import { cn } from "../lib/utils";

interface PhoneFrameProps {
  /** Screenshot URL — a bundled asset from `../assets` (see `assets/index.ts`). */
  src: string;
  /** Alt text describing the screen for assistive tech. */
  alt: string;
  className?: string;
  /** Eager-load the hero frame; lazy-load the rest. */
  priority?: boolean;
}

/**
 * A CSS phone bezel that wraps a mobile screenshot so the marketing landing
 * page shows native iOS simulator captures. Preserve the original image's
 * proportions and status bar, without cropping or adding a second notch.
 */
export function PhoneFrame({
  src,
  alt,
  className,
  priority = false,
}: PhoneFrameProps): ReactNode {
  return (
    <div
      className={cn(
        "relative w-full rounded-[2.25rem] border border-white/60 bg-neutral-900 p-2 shadow-[0_30px_60px_-25px_rgba(38,0,110,0.55)] ring-1 ring-black/5",
        className,
      )}
    >
      <div className="overflow-hidden rounded-[1.65rem] bg-surface-container-lowest">
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          className="block h-auto w-full"
        />
      </div>
    </div>
  );
}
